"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var test_attributes_1 = require("@carvana/test-attributes");
var react_1 = require("react");
var Switch_styles_1 = require("./Switch.styles");
var Switch = (0, react_1.forwardRef)(function (props, ref) {
    var id = props.id, _a = props.size, size = _a === void 0 ? 'default' : _a, rest = __rest(props, ["id", "size"]);
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    return ((0, jsx_runtime_1.jsxs)(Switch_styles_1.Root, __assign({}, getTestAttributes('switch'), { "data-testid": "switch" }, { children: [(0, jsx_runtime_1.jsx)(Switch_styles_1.Input, __assign({}, rest, { role: "switch" }, getTestAttributes('switch-input'), { id: id, type: "checkbox", ref: ref })), (0, jsx_runtime_1.jsx)(Switch_styles_1.Track, __assign({ className: "switch__track", size: size }, { children: (0, jsx_runtime_1.jsx)(Switch_styles_1.Thumb, { className: "switch__thumb", size: size }) }))] })));
});
exports.Switch = Switch;
